export default __webpack_public_path__ + "static/media/bbcnewsLogo.ce86c07c.svg";